/* When taking a snapshot of a piece of content, periodic preview functioanlity becomes unavailable;
So, this is a basic "do nothing" function to have in place of other functions (like updateText)
when that functionality is not available to the content type. */
export const doNothing = (): void => {
  /* do nothing */
}
